import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-logout',
  imports: [],
  templateUrl: './logout.html'
})
export class Logout {

}

